module.exports = __webpack_public_path__ + "media/site_templates/www.lawnmowingservices.me/images/splash-0792c17787b65613f34715e5a3d3335a.jpg";